import React from 'react';
import styles from './Button.module.css';
import { classNames } from 'shared/lib/classNames';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'caution' | 'light' | 'clear';
  children: React.ReactNode;
  className?: string;
}

export const Button = (props: ButtonProps) => {
  const { children, className, variant = 'primary', ...otherProps } = props;

  return (
    <button className={classNames(styles.Button, {}, [className, styles[variant]])} {...otherProps}>
      {children}
    </button>
  );
};
